<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show">
                    <v-toolbar dark color="blue">
                        <v-toolbar-title class="my-0 py-0">Nuevo Requisito Legal</v-toolbar-title>
                        <v-spacer></v-spacer>
                        Código: {{ codgral }}
                    </v-toolbar>
                </v-card>
                <v-card color="blue lighten-4">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="3">
                                <v-select dense v-model="alcance" :items="alcances" label="Alcance" item-text="detalle"
                                    item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="4">
                                <v-select dense v-model="aspecto" :items="aspectos" label="Aspecto" item-text="detalle"
                                    item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="4">
                                <v-select dense v-model="tipo" :items="tipos" label="Tipo" item-text="detalle"
                                    item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="1">
                                <v-text-field label="ID" dense v-model="codigo">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Norma" dense v-model="norma">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Emisor" dense v-model="emisor">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Autoridad" dense v-model="autoridad">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-select dense v-model="ar" :items="itemsar" label="A/R" item-text="detalle"
                                    item-value="valor"></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea label="Descripción" dense rows="2" auto-grow v-model="descr">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea label="Observaciones" dense rows="2" auto-grow v-model="observ">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="8" md="2">
                                <v-text-field label="Aspecto Ambiental" dense v-model="aspectoamb">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="4" md="1">
                                <v-btn class="mx-2" @click="botonAspecto" dark small color="primary">
                                    <v-icon dark>
                                        mdi-arrow-left-bold
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="6" sm="8" md="9">
                                <v-select dense v-model="filtroaspectoamb" :items="aspectosamb" item-text="descr"
                                    item-value="codigo"></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea label="Obligaciones" dense rows="2" auto-grow v-model="oblig">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="3">
                                <v-select dense v-model="estado" :items="estados" label="Estado" item-text="detalle"
                                    item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Fecha" dense v-model="fecha">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="blue" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>

<script>
import axios from "../../../axios-auth.js";
import moment from "moment";
export default {
    data: (vm) => ({
        lazy: false,
        valid: false,
        codgral: "",
        codigo: "",
        aspecto: "",
        aspectoamb: "",
        oblig: "",
        estado: "A",
        norma: "",
        emisor: "",
        ar: "",
        autoridad: "",
        descr: "",
        alcance: "",
        fecha: "",
        observ: "",
        tipo: "",
        deshabilitar: false,
        estados: [{ detalle: "Activa", valor: "A" },
        { detalle: "Inactiva", valor: "I" },
        ],
        tipos: [{ detalle: "Agua", valor: "Agua" },
        { detalle: "Aire", valor: "Aire" },
        { detalle: "Ascensores y Montacargas", valor: "Ascensores y Montacargas" },
        { detalle: "Combustible", valor: "Combustible" },
        { detalle: "Energía", valor: "Energía" },
        { detalle: "Enfermedades No Profesionales", valor: "Enfermedades No Profesionales" },
        { detalle: "Estudios de Impacto Ambiental", valor: "Estudios de Impacto Ambiental" },
        { detalle: "Flora y Fauna", valor: "Flora y Fauna" },
        { detalle: "Matafuegos y Aparatos Sometidos a Presión", valor: "Matafuegos y Aparatos Sometidos a Presión" },
        { detalle: "Medicina Laboral", valor: "Medicina Laboral" },
        { detalle: "Normativa General", valor: "Normativa General" },
        { detalle: "Ordenamiento Territorial", valor: "Ordenamiento Territorial" },
        { detalle: "Organismos", valor: "Organismos" },
        { detalle: "Permisos y Habilitaciones", valor: "Permisos y Habilitaciones" },
        { detalle: "Radicación Industrial", valor: "Radicación Industrial" },
        { detalle: "Radiaciones Electromagnéticas", valor: "Radiaciones Electromagnéticas" },
        { detalle: "Residuos Especiales - Peligrosos", valor: "Residuos Especiales - Peligrosos" },
        { detalle: "Residuos Industriales asimilables a RSU", valor: "Residuos Industriales asimilables a RSU" },
        { detalle: "Ruidos", valor: "Ruidos" },
        { detalle: "Seguridad en la Construcción", valor: "Seguridad en la Construcción" },
        { detalle: "Seguros Ambientales", valor: "Seguros Ambientales" },
        { detalle: "Suelo", valor: "Suelo" },
        { detalle: "Sustancias Químicas", valor: "Sustancias Químicas" },
        { detalle: "Tránsito y Seguridad Vial", valor: "Tránsito y Seguridad Vial" },
        { detalle: "Transporte de Cargas", valor: "Transporte de Cargas" },
        { detalle: "Transporte de Mercancías Peligrosas por Carretera", valor: "Transporte de Mercancías Peligrosas por Carretera" },
        { detalle: "Otro", valor: "Otro" },
        ],
        alcances: [{ detalle: "Nacional", valor: "N" },
        { detalle: "Provincial", valor: "P" },
        { detalle: "Municipal", valor: "M" },
        { detalle: "CABA", valor: "C" },
        ],
        aspectos: [{ detalle: "Medio Ambiente", valor: "M" },
        { detalle: "SST", valor: "S" },
        { detalle: "Otros", valor: "O" },
        ],
        itemsar: [{ detalle: "Aplicable", valor: "A" },
        { detalle: "Referencia", valor: "R" },
        ],
        filtroaspectoamb: "",
        aspectosamb: [],
    }),
    computed: {
        show: {
            get() {
                this.cargarcodigo();
                this.cargaraspectosamb();
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargaraspectosamb() {
            let self = this;
            axios
                .get("/Sgi/Aspectosambientales?")
                .then((response) => {
                    self.aspectosamb = response.data;
                })
                .catch((error) => {
                    self.aspectosamb = [];
                    console.log(error);
                });
        },
        cargarcodigo() {
            let self = this;
            axios
                .get("/Sgi/CodigoRequisito?")
                .then((response) => {
                    self.codgral = response.data;
                    console.log(self.codgral);
                })
                .catch((error) => {
                    self.codgral = "";
                    console.log(error);
                });
        },
        botonAspecto() {
            this.aspectoamb = this.aspectoamb + this.filtroaspectoamb + " - ";
            // this.mail.push(this.correos);
        },

        guardar() {
            this.$swal({
                title: "Guardar Requisito Legal",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;

                    var datos = {
                        codgral: this.codgral,
                        codigo: this.codigo,
                        aspecto: this.aspecto,
                        alcance: this.alcance,
                        norma: this.norma,
                        oblig: this.oblig,
                        emisor: this.emisor,
                        ar: this.ar,
                        tipo: this.tipo,
                        aspectoamb: this.aspectoamb,
                        fecha: this.fecha,
                        autoridad: this.autoridad,
                        estado: this.estado,
                        observ: this.observ,
                        descr: this.descr,
                    };
                    let self = this;
                    axios
                        .post("/SGI/GuardarRequisito", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Requisito Legal guardado con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
        vaciarModels() {
            this.codgral = "";
            this.codigo = "";
            this.aspecto = "";
            this.oblig = "";
            this.estado = "A";
            this.norma = "";
            this.aspectoamb = "";
            this.alcance = "";
            this.fecha = "";
            this.descr = "";
            this.emisor = "";
            this.autoridad = "";
            this.observ = "";
            this.tipo = "";
            this.ar = "";
            this.deshabilitar = false;
            this.$router.push({ name: "MainSgi" });
        },
    },
}
</script>